import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, Icon} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující soubory přiložené k objednávce.
 */
class PrilozeneSouboryPanel extends Component<WithTranslation> {

    static propTypes = {
        souboryList: PropTypes.array.isRequired, // seznam souborů objednávky (ObjednavkaSouborVO)
        onClick: PropTypes.func, // volitelná funkce při kliknutí na soubor, pokud není předána, nebudou soubory klikatelné
        onStahnoutVse: PropTypes.func, // volitelná funkce při kliknutí na Stáhnout vše, pokud není předána, tlačítko se nezobrazí
    };

    renderSoubor = (soubor) => {
        const {onClick} = this.props;
        let atributyContent = null;
        if (soubor.objednavkaSouborAtributList && soubor.objednavkaSouborAtributList.length > 0) {
            atributyContent = <span className={"ml-3"}>
                {soubor.objednavkaSouborAtributList.map(souborAtribut => {
                return `${souborAtribut.nazevAtribut}: ${souborAtribut.hodnotaAtribut}`
            }).join(", ")}
            </span>
        }
        const file = <span><Icon icon="file" /> {soubor.nazevSoubor}</span>;
        return onClick ? <CardBody key={soubor.id}>
                <a href="#" onClick={onClick.bind(this, soubor)}>{file}</a>
                {atributyContent}
            </CardBody> : <CardBody key={soubor.id}>{file}</CardBody>;
    };

    renderActions = () => {
        const {onStahnoutVse, t} = this.props;
        if (onStahnoutVse && typeof onStahnoutVse === "function") {
            return <ButtonToolbar>
                <Button onClick={onStahnoutVse}>{t('download_all')}</Button>
            </ButtonToolbar>
        } else return null;
    };

    render() {
        const {souboryList, t} = this.props;
        const maSoubory = souboryList && Array.isArray(souboryList) && souboryList.length !== 0;

        let content;
        if (maSoubory) {
            content = souboryList.map(this.renderSoubor)
        } else {
            content = <i>{t('no_files')}</i>
        }

        return <Card>
            <CardHeader>
                <ActionsRow actions={maSoubory ? this.renderActions() : null}>
                    <h2>{t('included_files', {count: souboryList.length})}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                {content}
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(PrilozeneSouboryPanel));
